import { render, staticRenderFns } from "./modalRecoverPassword.vue?vue&type=template&id=48141d7e&scoped=true"
import script from "./modalRecoverPassword.vue?vue&type=script&lang=js"
export * from "./modalRecoverPassword.vue?vue&type=script&lang=js"
import style0 from "./modalRecoverPassword.vue?vue&type=style&index=0&id=48141d7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48141d7e",
  null
  
)

export default component.exports